export default {"src":"/_next/static/media/hardware.51b92114.svg","height":20,"width":30};